import { Typography, TypographyType } from '../shared';

interface SidebarFiltersProps {
  children: React.ReactNode;
}

const SidebarFilters = ({ children }: SidebarFiltersProps) => {
  return (
    <>
      <Typography type={TypographyType.H3}>Filters</Typography>
      <div className="flex h-full flex-col gap-2 overflow-y-auto pb-4">{children}</div>
    </>
  );
};

export default SidebarFilters;
